<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  watch: {
    $route: {
      handler: to => {
        document.title = "ARXeditor | " + to.meta.title || "ARXeditor";
      },
      immediate: true
    }
  },
  mounted() {
    this.$root.$on("body-background-color", function(color) {
        document.body.style = "background:" + color;
    });
}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
